module.exports = __webpack_public_path__ + "img/bg3.eff10050.jpg";